
export class DeliveryTypeGroup {
  id: number;
  name: string;
 }
